module.exports = __webpack_public_path__ + "components/home-header/static/header-2--small-2cb5107e05ab0d52a008918a2fd761cb.jpg";